module.exports = __webpack_public_path__ + "static/media/percent.3d60824b.svg";